module.exports = __webpack_public_path__ + "img/ai-ct.9b293ccb.png";